<template>
  <div class='coursework-viewer__slide'>
    <div class='js-video-player-container'>
      <div class='js-video-player'></div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      media: Object
    },
    data() {
      return {
        player: null
      }
    },
    methods: {
      init() {
        const mediaUrls = {
          h264_360_url: this.media.h264_360_url,
          h264_720_url: this.media.h264_720_url
        };
        this.player = new Kadenze.VideoPlayer($(this.$el), mediaUrls, 'vjs-student-skin', null, null, {displayMode: 'gallery'});
        this.player.addEventListener('ready', () => {
          this.$emit('ready', this.media.id)
        });
        return this.player;
      },
      pause() {
        this.player && this.player.pause();
      }
    },
    created() {
      this.$parent.slides.push(this);
    },
    mounted() {
      this.init();
    }
  }
</script>
